<template>
	<div class="recycle_bin_table">
		<div class="table">
			<el-table :height="590" ref="multipleTable" :border="false" :data="tableData" tooltip-effect="dark"
				style="font-size: 0.75rem;" @selection-change="handleSelectionChange">
				<el-table-column align="center" type="selection" label="">
				</el-table-column>
				<el-table-column align="center" label="产品编号" width="100">
					<template slot-scope="scope">{{ scope.row.goods_sn }}</template>
				</el-table-column>
				<el-table-column align="center" label="产品信息" width="280" >
					<template slot-scope="scope">
						<div class="d-flex flex-row j-sb a-center">
							<img :src="scope.row.goods_thumb" alt=""
								style="width: 3.75rem;height: 3.75rem;margin-right: 0.69rem;border-radius: 0.25rem;">
							<div class="flex-1 d-flex flex-column j-sb a-start"
								style="line-height: 1;height: 3.75rem;text-align: left;">
								<span class="suojin">{{scope.row.goods_name}}</span>
								<span>发布时间{{scope.row.add_time}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="shop_price" label="价格" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="goods_number" label="库存" width="120" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="sales_volume" label="销量" show-overflow-tooltip>
				</el-table-column>
				<el-table-column align="center" prop="address" label="操作" width="310" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button size="mini"
							style="background: #1E69FF;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="revercy(scope.row)">恢复到仓库</el-button>
						<el-button size="mini"
							style="background: #FF9D1F;color: #FFFFFF; width: 5rem;height: 1.4rem;line-height: 1.4rem;padding: 0;"
							round @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<i class="el-icon-delete" style="margin-left: 10px;cursor: pointer;font-size: 1.3rem;"
							@click="handleDelete( scope.row)"></i>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<footer class="d-flex j-sb a-center">
			<div class="d-flex a-center">
				<div @click="thoroughDel" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;margin-right: 2rem; text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					彻底删除</div>
				<div @click="resumeWarsehouse" style="cursor: pointer; width: 5.63rem; height: 1.25rem;line-height: 1.25rem;text-align: center; font-size: 0.75rem;font-weight: bold;border: 2px solid #000000;border-radius: 0.625rem;">
					恢复到仓库</div>
			</div>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, total" :total="total_records">
			</el-pagination>
		</footer>
	</div>
</template>

<script>
	export default {
		props:{
			keyword: {
		        type: String,
		        default: null
		    }
		},
		data() {
			return {
				currentPage: 1, //初始页
				pageSize : 10,
				tableData: [],
				total_records : 0,
				goods_ids : [],
				status : ''
			}
		},
		methods: {
			getRecyclegoods(){
				let param = {
					act : 'goods_list',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					type : 3,
					keyword : this.keyword,
					page : this.currentPage,
					size : this.pageSize
				}
				this.$api.goods_list(param).then((res)=>{
					this.tableData = []
					if(res.code == 0){
						this.tableData = res.data
						this.total_records = parseInt(res.total_records)
					}
				})
			},
			// 恢复到仓库 彻底删除
			delResume(){
				let param = {
					act : 'del_recovery',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					goods_ids : this.goods_ids.join(','),
					ctrl : this.status
				}
				this.$api.goods_list(param).then((res)=>{
					if(res.code == 0){
						this.$message.success(res.msg)
						this.getRecyclegoods()
					}else{
						this.$message.error('操作失败')
					}
				})
			},
			// 彻底删除
			thoroughDel(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个公司')
				}else{
					this.$msgbox.confirm('是否确认此操作?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.status = 'real_del'
						this.delResume()
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});  
					})
				}
			},
			// 恢复仓库
			resumeWarsehouse(){
				if(this.goods_ids.length == 0){
					this.$message.warning('请至少选择一个公司')
				}else{
					this.status = 'recovery'
					this.delResume()
				}
			},
			revercy(item){
				this.status = 'recovery'
				this.goods_ids.push(item.goods_id)
				this.delResume()
			},
			handleSizeChange(size) {
				this.pageSize = size;
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getRecyclegoods()
			},
			handleSelectionChange(val) {
				let goodsId = []
				val.forEach((item) => {
					goodsId.push(item.goods_id)
				})
				this.goods_ids = goodsId
			},
			handleEdit(index, row) {
				row.editStatus = false
				row.editState = 0
				this.$router.push({path:'edit_item',query:row})
			},
			handleDelete(row) {
				this.$msgbox.confirm('是否确认此操作?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.status = 'real_del'
					this.goods_ids.push(row.goods_id)
					this.delResume()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});  
				})
			},
		},
		mounted() {
			this.getRecyclegoods()
			this.$nextTick(function() {
				this.$on('childmethods',function(){
					let param = {
						act : 'goods_list',
						token: localStorage.getItem('token'),
						user_id: localStorage.getItem('user_id'),
						type : 3,
						keyword : this.keyword,
						page : this.currentPage,
						size : this.size
					}
					this.$api.goods_list(param).then((res)=>{
						this.tableData = []
						if(res.code == 0){
							this.tableData = res.data
							this.total_records = parseInt(res.total_records)
						}else {
							this.total_records = 0
						}
					})
				});
			});
		}
	}
</script>

<style lang="scss" scoped>
	.suojin{
		text-overflow: ellipsis;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.recycle_bin_table {
		.table {
			margin-top: 1.44rem;
			width: 100%;
			background: #FFFFFF;
			border-radius: 6px;
			overflow: hidden;
		}
		footer {
			width: 100%;
			height: 3.85rem;
			background: #FFFFFF;
			margin-top: 1.44rem;
			border-radius: 6px;
			padding: 0 1.25rem;
			box-sizing: border-box;
		}
	}
</style>
